import { render, staticRenderFns } from "./addMessageBox.vue?vue&type=template&id=0db297cd"
import script from "./addMessageBox.vue?vue&type=script&lang=js"
export * from "./addMessageBox.vue?vue&type=script&lang=js"
import style0 from "./addMessageBox.vue?vue&type=style&index=0&id=0db297cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports